import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=7274393e"
import script from "./RichTextField.vue?vue&type=script&lang=js"
export * from "./RichTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports